export default [
  {name: '전체', value: ''},
  {name: '파일명', value: 'FILE_NAME'},
  {name: '이미지항목 + 파일명', value: 'IMAGE_TYPE'}
];
